<div class="modal-gs p-3 d-flex flex-column gap-3">
    <header class="d-flex justify-content-between align-items-center">
        <h4 class="modal-title fs-5 pull-left" *ngIf="modalStatus.isCreate">{{'VERSIONS.NEW' | translate}}</h4>
        <h4 class="modal-title fs-5 pull-left" *ngIf="modalStatus.isPatch">{{'VERSIONS.EDIT' | translate}}</h4>
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </header>

    <div class="modal-gs-body">
        <form class="d-flex flex-column gap-3" [formGroup]="form">

            <div class="form-group">
                <label for="vehicleType">{{'VEHICLES.VEHICLE_TYPE' | translate}}</label>
                <dropdown-primary-vehicle-type 
                    [isDisable]="dropdownsDisable.vehicleType"
                    [vehicleTypeId]="version?.vehicleTypeId"
                    (onSelectedEvent)="onVehicleTypeSelected($event)">
                </dropdown-primary-vehicle-type>
            </div>

            <div class="form-group">
                <label for="fuelType">{{'VEHICLES.FUEL_TYPE' | translate}}</label>
                <dropdown-primary-fuel-type 
                    [isDisable]="dropdownsDisable.fuelType"
                    [fuelTypeId]="version?.fuelTypeId"
                    (onSelectedEvent)="onFuelTypeSelected($event)">
                </dropdown-primary-fuel-type>
            </div>

            <div class="form-group">
                <label for="make" class="form-label">{{'VEHICLES.MAKE' | translate}}</label>
                <dropdown-primary-make
                    [isDisable]="dropdownsDisable.make"
                    [makeId]="version?.makeId"
                    (onSelectedEvent)="onMakeSelected($event)">
                </dropdown-primary-make>
            </div>

            <div class="form-group">
                <label for="model" class="form-label">{{'VEHICLES.MODEL' | translate}}</label>
                <dropdown-primary-model
                    [isDisabled]="dropdownsDisable.model"
                    [modelId]="version?.modelId"
                    [makeId]="form.get('makeId')?.value"
                    (onSelectedEvent)="onModelSelected($event)">
                </dropdown-primary-model>
            </div>

            <div class="form-group">
                <label for="name" class="form-label">{{'NAME' | translate}}</label>
                <input type="text" class="form-control" formControlName="name">
            </div>

            <div class="form-group">
                <label for="vin-codee" class="form-label">Vin code</label>
                <input type="text" class="form-control" formControlName="vinCode">
            </div>

            <formly-form [form]="form" [fields]="fields"></formly-form>

            <button type="button" class="btn-gs-danger-noborder width-fit-content" (click)="deleteVehicleVersion()" *ngIf="modalStatus.isPatch">
                {{'ACTIONS.DELETE' | translate}}
            </button>

        </form>
    </div>

    <footer class="d-flex gap-2 align-items-center justify-content-center">
        <button type="button" class="btn-gs-secondary" (click)="bsModalRef.hide()">{{'ACTIONS.CANCEL' | translate}}</button>

        <button type="button" class="btn-gs-primary" *ngIf="modalStatus.isCreate" (click)="createVehicleVersion()">{{'ACTIONS.NEW' | translate}}</button>
        <button type="button" class="btn-gs-primary" *ngIf="modalStatus.isPatch" (click)="updateVehicleVersion()">{{'ACTIONS.EDIT' | translate}}</button>
    </footer>
</div>